export { default } from './TravelResultItemTile'
